import React from "react";

const CmsPreviewShell = ({ title, subtitle, children }) => (
  <div className="cms-preview">
    {title && <h4 className="cms-preview__title">{title}</h4>}
    {title && subtitle?.trim() && (
      <p className="cms-preview__subtitle">{subtitle}</p>
    )}
    <div className="cms-preview__body">{children}</div>
  </div>
);

export default CmsPreviewShell;
